import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import { FormBuilderSwitch } from "../components/Switch";
import FontFamilySelect from "../components/FontFamilySelect";

const SubmitButtonGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };

  const handleTextAlignChange = (event) => {
    dispatch({
      type: ACTIONS.SUBMIT_TEXT_ALIGN_INPUT,
      payload: event.target.value,
    });
  };

  const handleFontWeightChange = (event) => {
    dispatch({
      type: ACTIONS.SUBMIT_FONT_WEIGHT_INPUT,
      payload: event.target.value,
    });
  };

  const handleButtonAlignChange = (event) => {
    dispatch({
      type: ACTIONS.SUBMIT_BUTTON_ALIGN_INPUT,
      payload: event.target.value,
    });
  };

  const handleSubmitWidthUnitsChange = (event) => {
    dispatch({
      type: ACTIONS.SUBMIT_WIDTH_UNITS,
      payload: event.target.value,
    });
  };

  const handleToggleBackgroundImage = (event) => {
    dispatch({
      type: ACTIONS.SUBMIT_TOGGLE_BACKGROUND_IMAGE,
      payload: event.target.checked,
    });
  };

  const handleFontFamilyChange = (event) => {
    dispatch({
      type: ACTIONS.SUBMIT_FONT_FAMILY_CHANGE,
      payload: event.target.value,
    });
  };

  return (
    <div>
      <div>
        <h2 className="section-subheader">General styles</h2>
        <div className="input-group-wrapper">
        <div className="form-builder-section-div">
            <p>Button Text</p>
            <div className="input-div">
              <input
                type="text"
                id="submitButtonText"
                value={state.submitButtonText}
                onChange={(e) =>
                  dispatch({
                    type: ACTIONS.SUBMIT_TEXT_INPUT,
                    payload: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Margin Top */}
          <InputSection
            id="submitMarginTop"
            title="Margin Top"
            value={state.submitMarginTop}
            actionTypeIncrement={ACTIONS.SUBMIT_MARGIN_TOP_INCREMENT}
            actionTypeDecrement={ACTIONS.SUBMIT_MARGIN_TOP_DECREMENT}
            actionTypeInput={ACTIONS.SUBMIT_MARGIN_TOP_INPUT}
            dispatch={dispatch}
          />
          <InputSection
            id="submitHeight"
            title="Height"
            value={state.submitHeight}
            actionTypeIncrement={ACTIONS.SUBMIT_HEIGHT_INCREMENT}
            actionTypeDecrement={ACTIONS.SUBMIT_HEIGHT_DECREMENT}
            actionTypeInput={ACTIONS.SUBMIT_HEIGHT_INPUT}
            dispatch={dispatch}
          />
          <InputSection
            id="submitWidth"
            title="Width"
            value={state.submitWidth}
            actionTypeIncrement={ACTIONS.SUBMIT_WIDTH_INCREMENT}
            actionTypeDecrement={ACTIONS.SUBMIT_WIDTH_DECREMENT}
            actionTypeInput={ACTIONS.SUBMIT_WIDTH_INPUT}
            dispatch={dispatch}
          />
          <div>
          <p>Width by units</p>
          <CustomSelect
            labelId="width-by-units"
            id="width-by-units"
            selectValue={state.submitWidthUnits}
            selectLabel="Width by units"
            selectOnChange={handleSubmitWidthUnitsChange}
            menuItems={[
              { value: "%", label: "%" },
              { value: "px", label: "px" },
            ]}
          />
        </div>

          <div>
            <p>Text Align</p>
            <CustomSelect
              labelId="submit-text-align-select"
              id="submit-text-align-select"
              selectValue={state.submitTextAlign}
              selectLabel="Select Text Align"
              selectOnChange={handleTextAlignChange}
              menuItems={[
                { value: "left", label: "Left" },
                { value: "center", label: "Center" },
                { value: "right", label: "Right" },
              ]}
            />
          </div>

          {/* <div className="form-builder-section-div">
            <p>Background Image</p>
            <div className="input-div">
              <input
                type="text"
                id="submitButtonImage"
                value={state.submitButtonText}
                onChange={(e) =>
                  dispatch({
                    type: ACTIONS.SUBMIT_TEXT_INPUT,
                    payload: e.target.value,
                  })
                }
              />
            </div>
          </div> */}
        </div>
      </div>
      <div>
        <h2 className="section-subheader">Font styles</h2>
        <div className="input-group-wrapper">
        <div className="form-builder-section-div">
              <p>Font Family</p>
              <FontFamilySelect
                selectedFontFamily={state.submitFontFamily}
                onFontFamilyChange={handleFontFamilyChange}
              />
            </div>
          <InputSection
            id="submitFontSize"
            title="Font Size"
            value={state.submitFontSize}
            actionTypeIncrement={ACTIONS.SUBMIT_FONT_SIZE_INCREMENT}
            actionTypeDecrement={ACTIONS.SUBMIT_FONT_SIZE_DECREMENT}
            actionTypeInput={ACTIONS.SUBMIT_FONT_SIZE_INPUT}
            dispatch={dispatch}
          />
          <div>
            <p> Button Font Weight</p>
            <CustomSelect
              labelId="font-weight-select-label"
              id="font-weight-select"
              selectValue={state.submitFontWeight}
              selectLabel="Select Font Weight"
              selectOnChange={handleFontWeightChange}
              menuItems={[
                { value: 100, label: "100" },
                { value: 200, label: "200" },
                { value: 300, label: "300" },
                { value: 400, label: "400" },
                { value: 500, label: "500" },
                { value: 600, label: "600" },
                { value: 700, label: "700" },
                { value: 800, label: "800" },
                { value: 900, label: "900" },
              ]}
            />
          </div>
        </div>
      </div>

      <div>
        <h2 className="section-subheader">Border styles</h2>
        <div className="input-group-wrapper">
          <InputSection
            id="submitBorderWidth"
            title="Border Width"
            value={state.submitBorderWidth}
            actionTypeIncrement={ACTIONS.SUBMIT_BORDER_WIDTH_INCREMENT}
            actionTypeDecrement={ACTIONS.SUBMIT_BORDER_WIDTH_DECREMENT}
            actionTypeInput={ACTIONS.SUBMIT_BORDER_WIDTH_INPUT}
            dispatch={dispatch}
          />

          <div className="form-builder-section-div">
            <p>Border Color</p>
            <ColorPickerInput
              color={state.submitBorderColor}
              onChange={handleColorChange(ACTIONS.SUBMIT_BORDER_COLOR_INPUT)}
            />
          </div>
          <InputSection
            id="submitBorderRadius"
            title="Border Radius"
            value={state.submitBorderRadius}
            actionTypeIncrement={ACTIONS.SUBMIT_BORDER_RADIUS_INCREMENT}
            actionTypeDecrement={ACTIONS.SUBMIT_BORDER_RADIUS_DECREMENT}
            actionTypeInput={ACTIONS.SUBMIT_BORDER_RADIUS_INPUT}
            dispatch={dispatch}
          />
        </div>
      </div>
      <div>
        <h2 className="section-subheader">Color styles</h2>
        <div className="input-group-wrapper">
          <div className="form-builder-section-div">
            <p>Text Color</p>
            <ColorPickerInput
              color={state.submitColor}
              onChange={handleColorChange(ACTIONS.SUBMIT_COLOR_INPUT)}
            />
          </div>
          <div className="form-builder-section-div">
            <p>Background Color</p>
            <ColorPickerInput
              color={state.submitBackground}
              onChange={handleColorChange(ACTIONS.SUBMIT_BACKGROUND_INPUT)}
            />
          </div>
        </div>
      </div>
      <div>
        <h2 className="section-subheader">Hover styles</h2>
        <div className="input-group-wrapper">
          <div className="form-builder-section-div">
            <p>Text Color</p>
            <ColorPickerInput
              color={state.submitColorHover}
              onChange={handleColorChange(ACTIONS.SUBMIT_COLOR_HOVER_INPUT)}
            />
          </div>
          <div className="form-builder-section-div">
            <p> Background Color</p>
            <ColorPickerInput
              color={state.submitBackgroundHover}
              onChange={handleColorChange(
                ACTIONS.SUBMIT_BACKGROUND_HOVER_INPUT
              )}
            />
          </div>

          <div className="form-builder-section-div">
            <p>Border Color</p>
            <ColorPickerInput
              color={state.submitBorderColorHover}
              onChange={handleColorChange(
                ACTIONS.SUBMIT_BORDER_COLOR_HOVER_INPUT
              )}
            />
          </div>
        </div>
      </div>
      


      <div>
        <div>
          <p>Add background image?</p>
          <FormBuilderSwitch
            checked={state.addBackgroundImage}
            onChange={handleToggleBackgroundImage}
          />
        </div>
        {state.addBackgroundImage && (
          <>
            <h2 className="section-subheader">Background image styles</h2>
            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Background image url</p>
                <div className="input-div">
                  <input
                    type="text"
                    id="submitBackgroundImage"
                    value={state.submitBackgroundImage}
                    onChange={(e) =>
                      dispatch({
                        type: ACTIONS.SUBMIT_BACKGROUND_IMAGE_INPUT,
                        payload: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <InputSection
                id="submitImageSize"
                title="Image Size"
                value={state.submitBackgroundImageSize}
                actionTypeIncrement={ACTIONS.SUBMIT_BACKGROUND_IMAGE_SIZE_INCREMENT}
                actionTypeDecrement={ACTIONS.SUBMIT_BACKGROUND_IMAGE_SIZE_DECREMENT}
                actionTypeInput={ACTIONS.SUBMIT_BACKGROUND_IMAGE_SIZE_INPUT}
                dispatch={dispatch}
              />
              <InputSection
                id="submitImagePOsitionRight"
                title="Image Padding Right"
                value={state.submitBackgroundImagePositionRight}
                actionTypeIncrement={ACTIONS.SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT}
                actionTypeDecrement={ACTIONS.SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT}
                actionTypeInput={ACTIONS.SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT}
                dispatch={dispatch}
              />
            </div>
          </>
        )}

      </div>
      <div>
        <h2 className="section-subheader">Alignment</h2>
        <div>
          <p>Button Alignment</p>
          <CustomSelect
            labelId="submit-alignment-select"
            id="submit-alignment-select"
            selectValue={state.submitButtonAlign}
            selectLabel="Select Button Alignment"
            selectOnChange={handleButtonAlignChange}
            menuItems={[
              { value: "left", label: "Left" },
              { value: "center", label: "Center" },
              { value: "right", label: "Right" },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default SubmitButtonGroup;
